import styled from '@emotion/styled'

import { HeadingS } from '@/components/Typography'
import { CONFIG } from '@/styles/emotion.config'

import { PRODUCTS } from './constants'
import Product from './Product'

const ProductsStyles = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  textAlign: 'left',
  gridGap: '1.5rem',

  [CONFIG.media.lg]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridRowGap: '3.5rem',
  },
})

const Products = () => (
  <>
    <HeadingS className="eu-sm-m">O que você precisa?</HeadingS>
    <ProductsStyles>
      {PRODUCTS.map((item, index) => (
        <Product key={`lpro${index}`} {...item} />
      ))}
    </ProductsStyles>
  </>
)

export default Products
